import { v4 } from "uuid";
import userImg from "../images/user.png";

export const resumeTemplate0 = [
  {
    type: 4,
    id: v4(),
    comName: "TextAndImg0",
    text: [
      '<h2>姓名</h2><p></p><ul><li><p><span style="color: #000000">關於您的簡短介紹</span></p></li><li><p><span style="color: #000000">畢業後從事工程師，專案經理到工程師主管，有8年資訊軟體產業經驗。</span></p></li><li><p><span style="color: #000000">曾參與國際知名品牌專案，於韓國、日本、新加坡等地出差，與當地團隊合作進行推廣活動。</span></p></li></ul>',
    ],
    image: [userImg],
  },
  {
    id: v4(),
    type: 7,
    text: [
      '<p></p><h2>工作經歷</h2><p></p><h3><strong>研發工程師主管 <span style="color: rgb(100, 123, 113)">• &nbsp;藝次元互動科技&nbsp;</span></strong></h3><p><span style="color: rgb(136, 136, 136)">八月 2021 - 九月 2022&nbsp;</span></p><p><strong><span style="color: #000000">改良內部開發流程，以提升開發效率與品質控管</span></strong></p><ul><li><p><span style="color: #000000">建立及教育團隊使用版本控制 (git)，加強團隊合作及共享開發工具</span></p></li><li><p><span style="color: #000000">製作及維護互動開發資訊文檔 (Notion)，提升部門與部門之間的透明度，並確保資訊的準確性</span></p></li></ul><p><strong>協助解決研發和活動過程中的技術問題</strong></p><ul><li><p>與不同廠商交流合作，以確保活動如期並順利進行</p></li><li><p>提供教育訓練以及培訓新同事現場解難的能力</p></li></ul><p><strong>根據市場趨勢及客戶需求，制定研究與開發方向</strong></p><ul><li><p>研究WebAR及ThreeJS等框架，在疫情中為客戶提供線上互動體驗的選擇</p></li><li><p>挑選線上課程，讓團隊成員持續進修及分享學習成果</p></li></ul>',
    ],
    image: [],
    comName: "Text0",
  },
  {
    id: v4(),
    image: [],
    type: 7,
    text: [
      '<h3><strong>技術專案經理 <span style="color: rgb(100, 123, 113)">• &nbsp;AIR Concepts Ltd</span></strong></h3><p><span style="color: rgb(136, 136, 136)">七月 2019 - 六月 2021&nbsp;</span></p><ul><li><p>擔任技術工程師，研發軟體新技術與測試新硬體，提供測試結果以及實現設計師的想法。</p></li><li><p style="text-align: start">擔任技術專案經理，從規劃、分析、設計、開發、測試，到最後演示、發佈、驗收等工作的執行與推動。</p></li><li><p style="text-align: start">擔任大型體驗館專案經理，為客戶於8間外包商中進行協調，讓各單位都清楚客戶要求及設計。</p></li><li><p style="text-align: start">往來大陸外包廠商檢視進度及測試。</p></li><li><p style="text-align: start">海外出差，與當地團隊合作，讓專案可以如期、如質的發佈。</p></li><li><p style="text-align: start">APP上架及管理，為客服人員制定報錯單及流程。</p></li></ul>',
    ],
    comName: "Text0",
  },
  {
    comName: "Text0",
    image: [],
    type: 7,
    text: [
      '<h3><strong>資深專案助理<span style="color: rgb(100, 123, 113)">• TFI Digital Media Limited</span></strong></h3><p><span style="color: rgb(136, 136, 136)">七月 2017 - 六月 2019&nbsp;</span></p><ul><li><p>協助專案經理處理專案之規劃、執行、監控、管理與協調，讓專案可以如期、如質的發佈。</p></li><li><p style="text-align: start">利用Scrum框架作為專案管理工具來改進開發工作流程。</p></li><li><p style="text-align: start">往來大陸外包廠商檢視進度、開會及測試。</p></li><li><p style="text-align: start">在每週例會上報告專案進度、風險或問題。</p></li><li><p style="text-align: start">為客戶進行產品介紹及演示，準備不同文件（會議記錄、用戶手冊、測試報告等）。</p></li></ul>',
    ],
    id: v4(),
  },
  {
    comName: "Text0",
    type: 7,
    id: v4(),
    image: [],
    text: [
      '<h3><strong>軟體工程師<span style="color: rgb(100, 123, 113)">• Mirum Agency</span></strong></h3><p><span style="color: rgb(136, 136, 136)">三月 2014 - 六月 2017&nbsp;</span></p><ul><li><p>擔任體感互動工程師，負責軟體之分析、設計以及程式撰寫。</p></li><li><p>擔任系統分析工程師，與專案經理密切合作，就客戶的變更請求、提供風險分析及解決方案。</p></li><li><p>研發軟體新技術與測試新硬體，提供測試結果以及實現設計師的想法。</p></li><li><p>為公司新人及實習生提供培訓課程，也擔任Code Review執行者，讓新人更快融入團隊。</p></li></ul><p></p><p></p>',
    ],
  },
  {
    id: v4(),
    type: 7,
    image: [],
    text: [
      '<h2>學歷</h2><p></p><p><span style="color: rgb(136, 136, 136)">2010 - 2013</span></p><h3 style="text-align: start"><strong>Monash University</strong></h3><h4 style="text-align: start"><strong>電子計算機科學</strong></h4><p style="text-align: start"></p>',
    ],
    comName: "Text0",
  },
  {
    comName: "Text2",
    image: [],
    type: 9,
    id: v4(),
    text: ["<h2>技能</h2>"],
  },
  {
    type: 9,
    id: v4(),
    text: [
      "<h3><strong>程式設計類</strong></h3><hr><ul><li><p>Unity3D</p></li><li><p>C#</p></li><li><p>ASP.NET Core</p></li></ul>",
      '<h3 style="text-align: start"><strong>體感應用類</strong></h3><hr><ul><li><p>Azure Kinect</p></li><li><p>Leap Motion</p></li><li><p>Vuforia</p></li></ul>',
      '<h3 style="text-align: start"><strong>資料庫設計類</strong></h3><hr><ul><li><p>MySQL</p></li><li><p>MS SQL</p></li><li><p>MongoDB</p></li></ul>',
    ],
    image: [],
    comName: "Text2",
  },
  {
    image: [],
    comName: "Text2",
    id: v4(),
    text: [
      "<h3><strong>網頁技術類</strong></h3><hr><ul><li><p>HTML</p></li><li><p>JavaScript</p></li><li><p>CSS3</p></li><li><p>Node.js</p></li><li><p>Three.js</p></li><li><p>Vue.js</p></li></ul>",
      "<p></p>",
      "<p></p>",
    ],
    type: 9,
  },
];

export const resumeTemplate1 = [
  {
    image: [userImg],
    text: [],
    type: 2,
    id: v4(),
    comName: "FullImg2",
  },
  {
    comName: "Text0",
    text: [
      '<h2 style="text-align: center">姓名</h2><p style="text-align: center"><span style="color: rgb(0, 0, 0)">關於您的簡短介紹</span></p>',
    ],
    id: v4(),
    image: [],
    type: 8,
  },
  {
    comName: "Text0",
    id: v4(),
    text: ["<h2>Skills</h2>"],
    type: 8,
    image: [],
  },
  {
    type: 10,
    text: [
      "<h3>Frontend</h3><hr><ul><li><p>HTML</p></li><li><p>CSS</p></li><li><p>SCSS</p></li><li><p>Canvas</p></li><li><p>jQuery</p></li><li><p>Javascript</p></li><li><p>Typescript</p></li><li><p>Rxjs  </p></li><li><p>Angularjs</p></li><li><p>Angular</p><p></p></li></ul>",
      "<h3>Backend</h3><hr><ul><li><p>NodeJS</p></li><li><p>ExpressJS</p></li><li><p>NestJS</p></li><li><p>Firebase</p></li><li><p>Websocket</p></li><li><p>GraphQL</p><p></p></li></ul><p></p><p></p><p></p><p></p>",
      "<h3>Others</h3><hr><ul><li><p>Git</p></li><li><p>Git Flow</p></li><li><p>Scrum</p></li><li><p>Python</p></li><li><p>Jira</p></li><li><p>Google Maps API</p><p></p></li></ul><p></p><p></p><p></p><p></p>",
    ],
    image: [],
    id: v4(),
    comName: "Text2",
  },
  {
    comName: "Text0",
    type: 8,
    text: ["<p></p><h2>經歷</h2>"],
    image: [],
    id: v4(),
  },
  {
    type: 8,
    id: v4(),
    text: [
      "<h3><strong>理立系統 2019.11 ~</strong></h3><ul><li><p>開發台鐵新一代列車控制系統 (Train Control)，改善在普悠瑪號出軌後，避免駕駛未依號誌行駛且行控中心無法掌握列車狀況的情形</p></li><li><p>開發台南自駕公車行控中心系統，管理台南高鐵站與科學園區的自駕公車，並整合智慧號誌，掌握路況</p></li><li><p>開發自駕車管理系統，可以即時掌握遠端自駕車狀況，管理車隊掌握車子與駕駛的狀況</p></li></ul>",
    ],
    comName: "Text0",
    image: [],
  },
  {
    image: [],
    text: [
      "<h3><strong>威煦軟體 2017.9 ~ 2019.11</strong></h3><ul><li><p>開發法規管理系統，管理與檢視公司在勞工安全等各方面，是否符合政府的合規要求</p></li><li><p>開發化學品理系統，管理受到管制的危險化學物品，掌握狀況以及快速向政府申報與管理</p></li><li><p>開發風險管理系統，分析工作場所危險的風險狀況，追蹤與檢視改善狀況</p></li></ul>",
    ],
    comName: "Text0",
    type: 8,
    id: v4(),
  },
  {
    image: [],
    comName: "Text0",
    type: 8,
    text: ["<p></p><h2>學歷</h2>"],
    id: v4(),
  },
  {
    comName: "Text2",
    text: [
      '<p><span style="color: rgb(136, 136, 136)">2016 - 2021</span></p><h3><strong>國立台灣大學</strong></h3><h4 style="text-align: start"><strong>經濟學系</strong></h4>',
      "<p><span>2020</span>年臺灣大學頤賢獎學金</p><p>2019年臺灣大學瑞銀投信獎學金</p><p>2018年臺灣大學頤賢獎學金</p>",
      "<p></p>",
    ],
    image: [],
    id: v4(),
    type: 10,
  },
];
